<template>
    <v-autocomplete
        :items="data"
        @input="$emit('input', $event)"
        :loading="loading"
        :error-messages="errors"
        v-bind="$props"
        >
    </v-autocomplete>
</template>

<script>
import { getItemMeasureUnits } from '../../services/stock/item';
export default {
    name: "PItemMeasureUnitsSearch",
    props: {
        label: String,
        value: [String, Number],
        rules: Array,
        readonly: Boolean,
        backgroundColor: String,
        outlined: Boolean,
        itemText: String,
        itemValue: String,
        dense: Boolean,
        hideDetails: [Boolean, String],
        itemId: Number
    },
    data() {
        return {
            loading: false,
            errors: [],
            data: []
        }
    },
    watch: {
        itemId(val) {
            this.$emit("input", null);
            this.data.splice(0, this.data.length);
            if(val === null || val === "") return;
            this.fetchItemMeasureUnits();
        }
    },
    methods: {
        async fetchItemMeasureUnits() {
            try {
                this.loading = true;
                let response = await getItemMeasureUnits(this.itemId);
                this.data = response.data;
                this.loading = false;
                this.clearErrors();
            } catch (error) {
                this.loading = false;
                let message = error.response ? error.response.data.message : error.message;
                this.errors.push(message);
            }
        },
        clearErrors() {
            this.errors.splice(0, this.errors.length);
        }
    },
    created() {
        if(this.itemId !== null && this.itemId !== "") this.fetchItemMeasureUnits();
    }
}
</script>

<style>

</style>